// Pages Turbo must never fetch on hover (owner 2026-10-17, "Turn off
// hover-fetching... just make sure it won't affect anything"). Turbo 8
// fetches a link's page when the mouse rests on it for a tenth of a second,
// so the click feels instant. The browser drops that copy when the mouse
// moves on, but the server has already built the page: for these pages
// that is about 1 to 20 MB and up to 4 seconds each, and it was a large
// part of the web server's memory spikes (the same person loading the same
// heavy page twice within 3 seconds, 23 to 32 times a day). Every other
// link keeps the head start, except a link into another department (below).
// Matched on the path only, any query string.
export const HEAVY_PAGE_PATHS = [
  /^\/sp\/placements(\/new)?\/?$/,
  /^\/sp\/check_in\/?$/,
  /^\/admin\/intern_tasks\/?$/,
  /^\/pr\/clients\/\d+\/dpk_press_clips\/?$/,
]

export function isHeavyPage(href) {
  try {
    const path = new URL(href, window.location.href).pathname
    return HEAVY_PAGE_PATHS.some((pattern) => pattern.test(path))
  } catch (_error) {
    return false
  }
}

// A page in a department area remembers that department for the shared
// pages after it (StaffBase#remember_current_department), and a hover-fetch
// is a page load: resting on a link into ANOTHER department switched the
// menus of the next shared page (Clients, Intern Tasks) without a click
// (committee seat B, owner 2026-10-20). Such a link waits for the click.
// The head names this page's department (shared/_view_as_head).
export const DEPARTMENT_SEGMENTS = { sm: "bmt", bm: "bmt", pr: "prt", sp: "spt", bf: "bft" }

export function departmentOf(href) {
  try {
    const segment = new URL(href, window.location.href).pathname.split("/")[1]
    return DEPARTMENT_SEGMENTS[segment] || null
  } catch (_error) {
    return null
  }
}

// A page with no department (the client portal under /sm/portal, sign-in)
// remembers none, so it has nothing to protect and keeps the head start.
export function leavesDepartment(href) {
  const here = document.querySelector('meta[name="team-department"]')?.content
  if (!here) return false
  const target = departmentOf(href)
  return target !== null && target !== here
}

document.addEventListener("turbo:before-prefetch", (event) => {
  if (isHeavyPage(event.target.href)) event.preventDefault()
  if (leavesDepartment(event.target.href)) event.preventDefault()
  // While a staffer views an intern, no hover-fetching at all (red team,
  // edge-case seat A): a hidden fetch can end the view (the hour, a changed
  // intern) and the words saying so would be shown to nobody.
  if (document.getElementById("view-as-bar")) event.preventDefault()
})
